import { z } from 'zod';

export const AdminBatchCounterSchema = z.union([z.string(), z.number()]).transform(Number).pipe(z.number().int().positive());
